import { slug } from '@magalu/mixer-utils';
import { CHAR_MAP } from './constants';
var slugifyCouponTitle = function slugifyCouponTitle(couponTitle) {
  if (!couponTitle) return '';
  var dollarSign = /R\$\s?(\d+)/;
  var thousandSeparator = /\.(\d{3})/g;
  var decimals = /,\d+/;
  var specialCharacters = /[,%!]/g;
  var dictionary = /[àáâãäåçèéêëìíîïñòóôõöùúûü]/g;
  var str = couponTitle.trim().replace(dollarSign, 'r$1').replace(thousandSeparator, '$1').replace(decimals, '').replace(specialCharacters, '').replace(dictionary, function (match) {
    return CHAR_MAP[match] || match;
  });
  return slug(str);
};
export var couponClick = function couponClick(data) {
  var couponName = data.couponName,
    sectionTitle = data.sectionTitle,
    screenName = data.screenName;
  return {
    content_id: "copiar-cupom:".concat(slugifyCouponTitle(sectionTitle), ":").concat(slug(couponName)),
    content_type: screenName,
    event: 'select_content'
  };
};
export var couponView = function couponView(data) {
  var couponName = data.couponName,
    sectionTitle = data.sectionTitle,
    screenName = data.screenName;
  return {
    content_id: "cupom-disponivel:".concat(slugifyCouponTitle(sectionTitle), ":").concat(slug(couponName)),
    content_type: screenName,
    event: 'view_content'
  };
};